module.exports = __webpack_public_path__ + "static/media/eurofins.da88822f.PNG";